import { isArray } from "./isArray";

export const isObject = function (o) {
	return o === Object(o) && !isArray(o) && typeof o !== "function";
};
